import { render, staticRenderFns } from "./ButtonTheFork.vue?vue&type=template&id=46f85308"
import script from "./ButtonTheFork.vue?vue&type=script&lang=js"
export * from "./ButtonTheFork.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports